module.exports = __webpack_public_path__ + "img/stock3.0caf4c20.png";